import { Status } from '@bitcine/cinesend-theme'
import Sidebar from '../sidebar'
import useAuth from '../../hooks/use_auth'
import { Outlet } from 'react-router-dom'

function AirlineCycleWrapper() {
  const { user, isLoading: isUserLoading, logOut } = useAuth()

  return (
    <>
      <Status pending={isUserLoading || logOut.isLoading} className='h-screen'>
        <div className='w-screen h-screen flex'>
          {user ? <Sidebar user={user} logOut={logOut} /> : null}
          <div className='w-full h-full overflow-auto ml-4 md:ml-0 pb-60'>
            <Outlet />
          </div>
        </div>
      </Status>
    </>
  )
}

export default AirlineCycleWrapper
